import React from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./floor-create-import-prompt.module.scss";
import IconYesFile from "../../../../dynamicicons/icon-file-yes";
import IconNoFile from "../../../../dynamicicons/icon-file-no";
import PinnedList from "../pinned-list";
import PinnedListHeader from "../pinned-list-header";

export interface FloorCreateImportPromptProps {
	onSelectUpload?: () => void;
	onSelectSkip?: () => void;
	onClose?: () => void;
}

export default function FloorCreateImportPrompt(
	props: FloorCreateImportPromptProps,
) {
	const { t } = useTranslation();

	return (
		<PinnedList>
			<PinnedListHeader
				label={t("dashboard.floor_create.upload_header")}
				onClose={props.onClose}
			/>

			<div className={styles.container}>
				<span className={styles.message}>
					{t("dashboard.floor_create.import_prompt_question")}
				</span>

				<div className={styles.buttonRow}>
					<button
						className={styles.buttonBox}
						onClick={props.onSelectUpload}
					>
						<IconYesFile />
						<span>{t("common.yes")}</span>
					</button>
					<div className={styles.buttonSpacer} />
					<button
						className={styles.buttonBox}
						onClick={props.onSelectSkip}
					>
						<IconNoFile />
						<span>{t("common.no")}</span>
					</button>
				</div>
			</div>
		</PinnedList>
	);
}
